require('./brokerWarrantsAdvancedBuyStep3.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const AdvancedBuySellWarrantSummary = require('components/broker/commons/advancedBuySellWarrantSummary/advancedBuySellWarrantSummary');
const { OKMessage } = require('commonsComponents/OKMessage');

const BrokerWarrantsAdvancedBuyStep3 = props => {
    const { immProductFile, immBrokerWarrantsAdvancedBuy, immStocksContract } = props;

    return (
        <div className="warrants-advanced-buy-step3">
            <header className="warrants-advanced-buy-step3__header">
                <h2 className="warrants-advanced-buy-step3__header-title">
                    {formatText('broker-stocksAdvancedBuyStep3HeaderTitle')}
                </h2>
                <p className="warrants-advanced-buy-step3__header-text">
                    {formatText('broker-stocksAdvancedBuyStep3HeaderText')}
                </p>
            </header>
            <AdvancedBuySellWarrantSummary
                immProductFile={immProductFile}
                immBrokerWarrantsAdvancedState={immBrokerWarrantsAdvancedBuy}
                immStocksContract={immStocksContract}
            />
            <section className="warrants-advanced-buy-step3__section">
                <OKMessage
                    id="warrants-advanced-buy-step3-disclaimer"
                    type="informative"
                    visible={true}
                    extraClass="warrants-advanced-buy-step3__disclaimer"
                >
                    <FormattedText value="broker-warrantsAdvancedBuyStep3DisclaimerWarning" />
                </OKMessage>
                <section className="warrants-advanced-buy-step3__clause-section-info-container">
                    <p className="warrants-advanced-buy-step3__clause-section-info">
                        <FormattedText value="broker-warrantsAdvancedBuyStep3Disclaimer" />
                    </p>
                </section>
                <p className="warrants-advanced-buy-step3__header-text">
                    {formatText('broker-warrantsAdvancedBuyStep3LastWarning')}
                </p>
            </section>
        </div>
    );
};

BrokerWarrantsAdvancedBuyStep3.propTypes = {
    immProductFile: PropTypes.object.isRequired,
    immBrokerWarrantsAdvancedBuy: PropTypes.object.isRequired,
    immStocksContract: PropTypes.object.isRequired
};

module.exports = BrokerWarrantsAdvancedBuyStep3;